import { useEffect } from "react";
import type { RefObject } from "react";
import type { CustomHTMLProps } from "../CustomHTML";
import { generateHtmlContent, setupResizeObserver } from "../utils";

export function useIframeContent(
  iframeRef: RefObject<HTMLIFrameElement>,
  options: Pick<CustomHTMLProps, "content" | "height">,
) {
  const { content, height } = options;
  const { head, body } = content;

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
    if (!iframeDoc) return;

    const htmlContent = generateHtmlContent({
      head,
      body,
    });

    iframeDoc.open();
    iframeDoc.write(htmlContent);
    iframeDoc.close();

    if (height === "auto" && iframe.contentWindow) {
      const resizeObserver = setupResizeObserver({
        iframe,
        iframeDoc,
      });

      return () => resizeObserver.disconnect();
    }

    return undefined;
  }, [content, height, iframeRef, head, body]);
}
